module.exports = __webpack_public_path__ + "img/adModal-empty.fd4a676b.png";